import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { StatiRiparazioneComponent } from 'src/app/admin/stati-riparazione/stati-riparazione.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => StatoRiparazionePickerComponent) },
  ],
  selector: 'stato-riparazione-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class StatoRiparazionePickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(StatiRiparazioneComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
